// Persists the logged user's session ({ name, token, exp }) so it survives reloads.
// Storage can throw (private mode, blocked site data), so every access is guarded.

const SESSION_KEY = 'je_session';
export const SESSION_EXPIRED_EVENT = 'je:session-expired';

const getSession = () => {
    try {
        const session = JSON.parse(localStorage.getItem(SESSION_KEY));
        return session && session.exp > Date.now() ? session : null;
    } catch {
        return null;
    }
};

// True when a session is stored but past its expiry. Logging out removes the
// session instead, so this tells "expired" apart from "logged out".
const hasExpiredSession = () => {
    try {
        const session = JSON.parse(localStorage.getItem(SESSION_KEY));
        return !!session && session.exp <= Date.now();
    } catch {
        return false;
    }
};

const saveSession = (session) => {
    try {
        localStorage.setItem(SESSION_KEY, JSON.stringify(session));
    } catch {}
};

const clearSession = () => {
    try {
        localStorage.removeItem(SESSION_KEY);
    } catch {}
};

export {
    getSession,
    hasExpiredSession,
    saveSession,
    clearSession,
}
